import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { AudioPreviewDialog } from '../../components/AudioPreviewDialog';
import { AppButton } from '../../common/components/AppButton';
import { AppHelper } from '../../helpers/AppHelper';
import { CommonStyles } from '../../styles/Styles';
import { DeleteModal } from '../../common/components/DeleteModal';

export class AudioAds extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'AudioAds'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.pageTitle = Helper.getString('audio-ads')
    this.uploadLocation = this.orgId
    this.noAdd = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.groupId = 'audioads' + this.orgId
    this.toFetch = [
      { method: 'GET', paths: ['items'], queryParams: { groupId: this.groupId, pb: 'fieldDef' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Title: (current) => AppHelper.itemTitleImage(current),
      // Status: (current) => {
      //   return UiHelper.itemStatusContainer(current)
      // }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.addNewLabel = 'Create Ad'
    this.emptyText = ' ' // Since above header shows the buttons
    this.apiData = {
      groupId: this.groupId
    }
    this.noTableHead = true
    this.allowAccessToRoles = ['VENUES']
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    this.setState({
      items: results[0].items
    })
    if(!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.emptyText = ''
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = false
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').defaultValue = this.selectedIType
    this.formDefinition.disableAlwaysFormFields = ['iType']
    this.formDefinition.steps[0].fields.find(i => i.key === 'descr').showCharCounter = true
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    })
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    })
  }

  onEdit(current) {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    delete this.formDefinition.disableAlwaysFormFields
    this.formDefinition.steps[0].fields.find(i => i.key === 'descr').showCharCounter = true
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    })
  }


  renderAboveTable() {
    if (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      return (<div>
        {this.state.preview &&
          <AudioPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            audio={this.state.current.audio}
            onClosed={() => this.setState({ preview: undefined })}
          />}
      </div>)
    }
    return (
      <div className={css(CommonStyles.aboveTableContainer)}>
        <div className={css(CommonStyles.buttonImageContainer, CommonStyles.imageMarginRight)}
          onClick={() => {
            this.apiData = { ...this.apiData, iType: 'TTS' }
            this.selectedIType = 'TTS'
            this.openModalForAdd()
          }}>
          <img src={require('../../assets/images/text_to_speach.png')}
            className={css(CommonStyles.buttonImage)} height='74' width='300' />
        </div>
        <div className={css(CommonStyles.buttonImageContainer)}
          onClick={() => {
            this.apiData = { ...this.apiData, iType: 'AUDIO' }
            this.selectedIType = 'AUDIO'
            this.openModalForAdd()
          }}>
          <img src={require('../../assets/images/upload_mp3.png')}
            className={css(CommonStyles.buttonImage)} height='74' width='300' />
        </div>
        {this.state.preview &&
          <AudioPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            audio={this.state.current.audio}
            onClosed={() => this.setState({ preview: undefined })}
          />}
      </div>)
  }

  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, this.previewButton(current), [])
    return actions
  }

  previewButton(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
          {/* <i className='material-icons-outlined' onClick={() => { this.setState({ preview: true, current }) }}>visibility</i> */}
        </span>
      </Tooltip>
    )
  }

  onDeleteAdComplete() {
    this.setState({
      modalOpen: false
    })
    this.fetchItems()
  }

  renderDeleteModal() {
    return (
      <DeleteModal open={this.state.modalOpen}
        onCancel={() => this.setState({ modalOpen: false })}
        onDeleteAdComplete={() => this.onDeleteAdComplete()}
        apiMethod={this.state.apiMethod}
        apiEndPoint={this.state.apiEndPoint}
      />
    );
  }

  renderModal() {
    if (this.formDefinition.formType === 'delete') {
      return this.renderDeleteModal()
    } else {
      return super.renderModal()
    }
  }
}

const Styles = StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/AudioAds.js